import {
  ApiAuthRefreshTokenFailedReason,
  ApiAuthRefreshTokenRequestedAction,
  apiAuthRefreshTokenFailed,
  apiAuthRefreshTokenSucceeded
} from '../../../api/auth/refreshApi';
import { call, put } from 'typed-redux-saga';
import refreshAnonymousTokenAction from '@spa/lib/actions/auth/refreshAnonymousTokenAction';

function* refreshTokenSaga({
  payload: { actionId: requestedActionId }
}: ApiAuthRefreshTokenRequestedAction): Generator {
  try {
    const result = yield* call(refreshAnonymousTokenAction, 'refreshAnonymousTokenAction');

    if (result !== null && result.__typename === 'RefreshTokenResultSucceeded') {
      yield* put(
        apiAuthRefreshTokenSucceeded({
          requestedActionId,
          tokens: result.tokens
        })
      );
    } else {
      yield* put(
        apiAuthRefreshTokenFailed({
          requestedActionId,
          reason: ApiAuthRefreshTokenFailedReason.TOKEN_INVALID
        })
      );
    }
  } catch {
    yield* put(
      apiAuthRefreshTokenFailed({
        requestedActionId,
        reason: ApiAuthRefreshTokenFailedReason.OTHER
      })
    );
  }
}

export default refreshTokenSaga;
